<template>
  <div>
  
    <div class="p-4">
      <CContainer>
        <CCard class="mt-5">
          <CCol sm="12" class="mt-3 mb-3">
            <CRow>
              <CCol sm="4">
                <CCard>
                  <span>
                    <img
                      v-if="packages.filePath == null"
                      src="../assets/img/default.png"
                    />

                    <img
                      v-else
                      style="background: #fff; max-width: 100%"
                      :src="photoURLs"
                    />
                  </span>
                </CCard>
              </CCol>
              <CCol sm="8">
                <h3 class="display-5 text-left">
                  Getting Started {{ packages.Name }}
                </h3>

                <br />
                <h5 class="display-6 text-left">
                  Date : <strong>{{ packages.DateTimeSchedule }} </strong>
                </h5>
                <h5 class="display-6 text-left">
                  Grade : <strong>{{ packages.Grade }} </strong>
                </h5>
              </CCol>
              <CCol sm="12">
                <CRow>
                  <CCol sm="8">
                    <h3 class="display-5 text-left">Class Overview</h3>

                    <h5 class="display-6 text-left">
                      {{ packages.Description }}
                    </h5>
                    <br />
                    <span
                      v-html="packages.PackageDescription"
                      style="font-size:font-size: 1rem;line-height: 1.5rem;"
                      class="display-6 text-left"
                    >
                      >
                    </span>
                    <br />

                    <h5 class="display-6 text-left">
                      Class Cost : RM <strong>{{ packages.Rate }} </strong>
                      <br />
                      Hour : <strong>1</strong> hour
                    </h5>
                  </CCol>
                  <CCol sm="4">
                    <h5 class="display-6 text-center"></h5>

                    <span class="p-3">
                      <!--  <label class="text-center">Don't have an account Pickiddo? </label>
                  <CButton color="primary" style="background-color:rgba(85,83,255)" type="button" block size="sm" :href="'/SignUp?codeId=' + packages.TuitionPackageId">Register Account</CButton>
                  <hr /> -->
                      <label class="text-center">Lets's Start Join Class</label>
                      <br />
                      <CButton
                        color="success"
                        type="button"
                        block
                        size="sm"
                        @click="GoToJoinClass(packages.ScheduleId)">Join Class</CButton
                      >
                    </span>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
        </CCard>
      </CContainer>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
import backgroundBanner from "../assets/img/bgApps.jpg";
Vue.use(VuejsDialog);
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      packages: [],
      SelectedPackage: "",
      PackageDescription: "",
      photoURLs: "",

      urlApp: [],
    };
  },
  async mounted() {
    this.GetAllPackages();
  },
  methods: {
    async GetAllPackages() {
      return this.$API
        .get(this.$PackageById + "?id=" + this.$route.query.id + "&scheduleId=" + this.$route.query.scheduleId)
        .then(
          function (response) {
            this.packages = response.data;
            this.photoURLs = "https://pickiddo.com" + this.packages.filePath;
          }.bind(this)
        )
        .catch(function (error) {
          console.log(error.response);
        });
    },
    GotoRegister() {
      this.$router.push(
        "https://pickiddo.com/OnlineClass/#/SignUp?targetUrl=%2FJoinGroup%3FcodeId%" +
          this.packages.TuitionPackageId
      );
    },
     GoToJoinClass(ScheduleId) {
      this.$router.push("JoinGroup?codeId=" + ScheduleId);
    },
  },
};
</script>
